import { faMoneyBillSimpleWave } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { T } from "@repo/transifex";

type LimitReachedHint = {
  intent: "limitReached";
  /** Units in this add that fall beyond the covered cap (exact for this add). */
  fullQuantity: number;
  /** Pre-formatted full unit price, shown for the units beyond the cap. */
  fullUnitPrice: string;
};

type UsedUpHint = {
  intent: "usedUp";
};

type BudgetInfoHint = {
  intent: "budgetInfo";
};

type AllowanceHintProps = LimitReachedHint | UsedUpHint | BudgetInfoHint;

const AllowanceHintMessage = (props: AllowanceHintProps) => {
  switch (props.intent) {
    case "limitReached":
      return (
        <T
          _str="Allowance limit reached · {extra} at full price ({price})"
          extra={props.fullQuantity}
          price={props.fullUnitPrice}
        />
      );
    case "usedUp":
      return <T _str="Allowance used up · charged at full price" />;
    case "budgetInfo":
      return <T _str="Allowance applies up to your spending limit" />;
  }
};

export const AllowanceHint = (props: AllowanceHintProps) => (
  <div className="mx-5 mt-4 flex items-center gap-3 rounded-2xl bg-kiosk-accent-secondary px-4 py-3 text-2xl font-semibold text-kiosk-text-primary">
    <FontAwesomeIcon icon={faMoneyBillSimpleWave} />
    <span>
      <AllowanceHintMessage {...props} />
    </span>
  </div>
);
